<app-header></app-header>
<div class="container-fluid">
  <div class="row">
   
      <main>
        <app-image-to-text1></app-image-to-text1>
      </main>
    
  </div>
</div>